import tabs from '../tabs/index';

const titles = tabs('product-tabs');
let mql = window.matchMedia('(min-width: 50em)');


function init() {
	if (!titles) {
		return;
	}

	screenTest();
	mql.addListener(screenTest);
}

function screenTest() {
	if (mql.matches) {
		titles.create();
	} else {
		titles.destroy();
	}
}

init();
